import React, {Component} from 'react';

class Footer extends Component {
  render() {
    return (
      <footer className="app-footer">
        <a href="http://epeople.com.br/">Epeople</a> &copy; {new Date().getFullYear()}.

      </footer>
    )
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js